import FormDataWithToken from "./FormDataWithToken"
import SearchRates from "./SearchRates"
import { SimpleValidate } from "./SimpleValidate"
import { currencyFormatter } from "./formatters"

const tes = document.getElementById('trade-equity-strong') as HTMLElement

document.querySelector('.js-set-trade')?.addEventListener('click', async () => {
    const tf = document.getElementById('trade-form') as HTMLFormElement
    const md = document.getElementById('trade-modal')
    const tv = document.getElementById('trade-value')
    const to = (document.getElementById('trade-owed') as HTMLInputElement)

    if (tf) {
        let vf = SimpleValidate.getInstance(tf)
        if (vf?.validate() && md) {
            if (md) {
                md.style.display = 'none'
            }

            let tradeValue = parseInt('0' + tv?.innerHTML.replace('$', '').replace(/,/g, ''))
            let tradeOwed = parseInt('0' + to?.value.replace('$', '').replace(/,/g, ''))
            let newVal = tradeValue - tradeOwed

            if (tes) tes.innerHTML = currencyFormatter.format(newVal)

            document.body.classList.add('has-trade')

            // Save Trade Equity
            let parms = new FormData(tf)
            await fetch('/details/citystate/vehicle?handler=SaveTradeEquity', { method: 'POST', body: parms })

            // Refresh Search
            const frm2 = document.getElementById('frmLoan') as HTMLFormElement
            var sr = SearchRates.getInstance(frm2)
            if (sr) sr.search()
        }
    }
})

document.querySelector('.js-remove-trade')?.addEventListener('click', async () => {
    if (tes) tes.innerHTML = currencyFormatter.format(0)

    document.body.classList.remove('has-trade')

    // Remove Trade
    await fetch('/details/citystate/vehicle?handler=RemoveTrade', { method: 'POST', body: new FormDataWithToken() })

    // Refresh Search
    const frm2 = document.getElementById('frmLoan') as HTMLFormElement
    var sr = SearchRates.getInstance(frm2)
    if (sr) sr.search()
})

const itv = document.querySelector('.input-trade-value') as HTMLFormElement
const taov = document.getElementById('trade-in-amount-owed-in-vehicle') as HTMLFormElement
const te = document.querySelectorAll('.trade-equity')

taov?.addEventListener('change', setTradeEquity)
itv?.addEventListener('change', setTradeEquity)

function setTradeEquity() {
    let tradeValue = Number(itv.value.replace(/[^0-9.]/g, ''))
    let tradeOwed = Number(taov.value.replace(/[^0-9.]/g, ''))
    let tradeEquity = tradeValue - tradeOwed

    document.querySelectorAll('.input-trade-value').forEach(m => (m as HTMLFormElement).value = tradeValue)
    document.querySelectorAll('.input-trade-owed').forEach(m => (m as HTMLFormElement).value = tradeOwed)

    if (te) {
        te.forEach(m => {
            m.innerHTML = currencyFormatter.format(tradeEquity)

            if (tradeEquity >= 0) {
                m.classList.add("text-green")
                m.classList.remove("text-red")
            }
            else {
                m.classList.remove("text-green")
                m.classList.add("text-red")
            }
        })
    }

    document.querySelectorAll('[search-rates]').forEach(triggerElement => {
        var sr = SearchRates.getInstance(triggerElement as HTMLElement)
        sr.search()
    })
}